export default {"src":"/_next/static/media/google-pay.ba28c5bb.svg","height":25,"width":63,"blurWidth":0,"blurHeight":0};